module.exports = __webpack_public_path__ + "images/unit-icons/10x35-parking_space.svg";